import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import EditModal from "./Modal";
import "./group-view.scss";
import { FiEdit } from "react-icons/fi";
import WithAuthentication from "Authentication/AuthenticationContext.ts";

import sendRequest from "hooks/useAxios";
import { NavLink } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { unixToPersianDate } from "utils/helperFunctions";
import { articleDataToQuery, productDataToQuery } from "utils/helperFunctions";
import Loader from "utils/Loader";
import { useContext } from "react";
import useWindowSize from "hooks/useWindowSize";

const GroupView = ({
  Component,
  numberOf = 1,
  type, //Product=0 , Blog=1
  id = 1,
  Color = "#203B8C",
  moreText,
  isNotEditable,
  idConfig,
  isFilteredPage = false,
  specificItems,
  index,
  titleHandler,
  displayHandler,
  findColor,
  tempColorList,
  tempTagList,
  tempBrandList,
  blogHashtags,
}) => {
  const [MainCheck, setMainCeheck] = useState([true, true, true, false, true]);
  const [MainCheck2, setMainCeheck2] = useState([true, true, true, true, true]);
  const [Mainlink, setMainLink] = useState("");
  const [sectionData, setSectionData] = useState({
    title: "",
    config: "",
    toggleDisplay: true,
  });
  const [modalData, setModalData] = useState();
  const [updater, setUpdater] = useState(true);
  const [brandList, setBrandList] = useState(tempBrandList);
  const [colorList, setColorList] = useState([]);
  const [items, setItems] = useState([]);
  const [tagList, setTagList] = useState(tempTagList);
  const [itemCount, setItemCount] = useState(0);

  const [isLoader, setIsLoader] = useState(false);
  const { width, height } = useWindowSize();

  let screen = useWindowSize().width;
  const auth = useContext(WithAuthentication);

  useEffect(() => {
    // setIsLoader(true);
    const hi = async () => {
      if (!isFilteredPage) {
        // let { data: temp } = await sendRequest("Find_color", {});
        // let tempColorList = temp.map((value) => {
        //   return { value: value.id, label: value.title, color: value.hex };
        // });
        // setColorList(tempColorList);

        // let { data: temp1 } = await sendRequest("Find_hashtags", {});
        // let tempTagList = temp1.map((value) => {
        //   return { value: value.id, label: value.txt };
        // });
        // setTagList(tempTagList);

        // let { data: temp2 } = await sendRequest("Find_brand", {});
        // let tempBrandList = temp2.map((value) => {
        //   return { value: value.id, label: value.name };
        // });
        // setBrandList(tempBrandList);
        let { data: temp3 } = await sendRequest("Find_boxs_configs", {
          conditions: `pagecode/=/${idConfig.pagecode}@@boxcode/=/${idConfig.boxcode}`,
        });

        setSectionData({
          title: temp3[0].title,
          config: temp3[0].custom_config,
          toggleDisplay: temp3[0].toggle_display == "1" ? true : false,
        });

        if (type == 1) {
          async function setData() {
            let queryObj = await {
              ...articleDataToQuery(temp3[0].custom_config, true, {
                tagList: tempTagList,
              }),
            };
            setModalData({
              ...queryObj,
              toggleDisplay: temp3[0].toggle_display == "1" ? true : false,
            });

            setSectionData((prev) => {
              return { ...prev, title: queryObj.title };
            });

            sendRequest("postfilter", {
              // hashtags: queryObj.tags.map((value) => value.value).toString(),
              date: queryObj.dateRange[0],
              hashtags:
                typeof queryObj.tags[0] == "object"
                  ? queryObj.tags.map((value) => value.value).toString()
                  : queryObj.tags.toString(),
              toTime: queryObj.dateRange[1],
            }).then(({ data }) => {
              setItems(
                data.items.reverse().map((value) => {
                  return {
                    title: value.title,
                    date: unixToPersianDate(value.mtm),
                    image: value.url,
                    mtm: value.mtm,
                    id: value.id,
                    description: value.description,
                  };
                })
              );
              // setIsLoader(false);
            });
          }
          setData();
        } else if (type == 0) {
          async function setData() {
            let queryObj = await {
              ...productDataToQuery(temp3[0].custom_config, true, {
                brandList: tempBrandList,
                colorList: tempColorList,
                tagList: tempTagList,
              }),
            };

            setModalData({
              ...queryObj,
              toggleDisplay: temp3[0].toggle_display == "1" ? true : false,
            });

            setSectionData((prev) => {
              return { ...prev, title: queryObj.title };
            });

            sendRequest("productfilter", {
              hashtags:
                typeof queryObj.tags[0] == "object"
                  ? queryObj.tags.map((value) => value.value).toString()
                  : queryObj.tags.toString(),

              brandId:
                typeof queryObj.brands[0] == "object"
                  ? queryObj.brands.map((value) => value.value).toString()
                  : queryObj.brands.toString(),
              // brandId: queryObj.brands.toString(),
              fromRate: queryObj.rankRange[0],
              toRate: queryObj.rankRange[1],
              fromPrice: queryObj.priceRange[0],
              toPrice: queryObj.priceRange[1],
              discount: queryObj.sortTypes.discounted,
              ascendingPrice: queryObj.sortTypes.cheapest,
              descendingPrice: queryObj.sortTypes.mostExpensive,
              ascendingTime: queryObj.sortTypes.newest,
              inventoryCount: queryObj.sortTypes.inventory,
            }).then(({ data }) => {
              // setIsLoader(false);

              setItems(
                data.items.reverse().map((value) => {
                  return {
                    name: value.title,
                    image: value.url,
                    id: value.id,
                    dis: value.description,
                    brand: value.brand.name,
                    price: value.main_price,
                    discount: value.main_discount,
                    score_count: value.rating_count,
                    score: value.avg_rating,
                  };
                })
              );
            });
          }
          setData();
        }
      } else {
        setItems([...specificItems]);
        // setIsLoader(false);
      }
    };

    hi();
  }, [updater, specificItems]);
  useEffect(() => {
    if (type == 1 || type == 0) {
      screen < 601 &&
        sectionData.title != "" &&
        titleHandler(`index${index}`, sectionData.title);
      screen < 601 &&
        displayHandler(`index${index}`, sectionData.toggleDisplay);
    }
  }, [sectionData]);

  useEffect(() => {
    setItemCount(items.length);
  }, [items]);
  return (
    <>
      {isLoader ? (
        <Loader></Loader>
      ) : (
        (sectionData.toggleDisplay == true || auth.userInfo.userType == 0) && (
          <>
            {" "}
            {items && (
              <div className="group-view">
                {screen > 601 && (
                  <div className="main-title mt-3 mb-2">
                    <div
                      className="d-flex flex-row justify-content-between"
                      style={{ marginBottom: "10px !important" }}
                    >
                      {sectionData.title == "" ? null : (
                        <div
                          className="title"
                          style={{
                            backgroundColor: `${Color}`,
                          }}
                        >
                          <h4>{sectionData.title}</h4>
                        </div>
                      )}
                      {moreText && (
                        <NavLink
                          to={`/${sectionData.config}`}
                          target="_blank"
                          className="mx-3"
                          style={{
                            textDecoration: "none",
                            marginTop: "20px",
                            fontSize: "15px",
                            color: Color,
                          }}
                        >
                          {moreText} <FaArrowLeft />
                        </NavLink>
                      )}
                    </div>

                    {sectionData.title == "" ? null : (
                      <div
                        className="line"
                        style={{
                          backgroundColor: `${Color}`,
                        }}
                      />
                    )}
                  </div>
                )}

                {auth.userInfo.userType == 0 && !isNotEditable && (
                  <div
                    className=" p-1 text-light rounded m-2"
                    style={{
                      backgroundColor: "navy",
                      display: "inline",
                      cursor: "pointer",
                      fontSize: "12px",
                    }}
                    data-bs-toggle="modal"
                    data-bs-target={`#Modal${id}`}
                  >
                    <FiEdit className=" rounded  mx-1"></FiEdit>
                    ویرایش
                  </div>
                )}
                <>
                  {" "}
                  <div className="text-end">
                    {moreText && screen < 601 && (
                      <NavLink
                        to={`/${sectionData.config}`}
                        target="_blank"
                        className="mx-3"
                        style={{
                          textDecoration: "none",
                          marginTop: "20px",
                          fontSize: "12px",
                          color: Color,
                        }}
                      >
                        {moreText} <FaArrowLeft />
                      </NavLink>
                    )}
                  </div>{" "}
                  <div
                    className={`d-flex flex-row flex-wrap container-item2 display-container-item2 ${
                      screen < 601 && "justify-content-around"
                    } mt-3`}
                  >
                    {items.map((item, index) =>
                      numberOf >= index + 1 ? (
                        <Component
                          data={item}
                          key={index}
                          title={type == 1 ? MainCheck2[0] : MainCheck[0]}
                          dis={type == 1 ? MainCheck2[3] : MainCheck[3]}
                          link={Mainlink}
                          price={type == 1 ? MainCheck2[1] : MainCheck[1]}
                          maker={type == 1 ? MainCheck2[4] : MainCheck[4]}
                          star={type == 1 ? MainCheck2[2] : MainCheck[2]}
                        />
                      ) : null
                    )}
                  </div>
                </>

                <div className="container-item2-sm d-none my-5">
                  <div className=" w-100">
                    <div className="text-center">
                      <Swiper
                        modules={[Navigation, Pagination]}
                        navigation={true}
                        slidesPerView={2}
                        slidesPerGroup={1}
                        // loop={true}
                        spaceBetween={5}
                        speed={500}
                        pagination={{ clickable: true }}
                        className="mySwiper pb-1"
                      >
                        {items.length > 0 ? (
                          items.map((item, index) =>
                            numberOf >= index + 1 ? (
                              <SwiperSlide key={index}>
                                <Component
                                  data={item}
                                  title={
                                    type == 1 ? MainCheck2[0] : MainCheck[0]
                                  }
                                  dis={type == 1 ? MainCheck2[3] : MainCheck[3]}
                                  link={Mainlink}
                                  price={
                                    type == 1 ? MainCheck2[1] : MainCheck[1]
                                  }
                                  maker={
                                    type == 1 ? MainCheck2[4] : MainCheck[4]
                                  }
                                  star={
                                    type == 1 ? MainCheck2[2] : MainCheck[2]
                                  }
                                />
                              </SwiperSlide>
                            ) : null
                          )
                        ) : (
                          <>در حال حاضر ایتمی وجود ندارد.</>
                        )}
                      </Swiper>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )
      )}

      {/* modall */}
      {!isNotEditable && (
        <EditModal
          modalData={modalData}
          type={type}
          id={id}
          idConfig={idConfig}
          setUpdater={setUpdater}
          brandList={tempBrandList}
          tagList={tempTagList}
          colorList={tempColorList}
          blogHashtags={blogHashtags}
        />
      )}
    </>
  );
};

export default GroupView;
